export default function RecentlyAddedPill() {
  return (
    <div className="rounded-full bg-flexcar-neutral100 px-2 py-1">
      <p className="body3-strong">Recently added</p>
    </div>
  );
}
